<template>
  <aside class="col-12 col-md-12 col-lg-2">
    <div class="sidebar box sticky-column">
      <ul class="nav">
        <li class="nav__item">
          <router-link to="/" exact>
            <em class="icon-user"></em> About
          </router-link>
        </li>
        <li class="nav__item">
          <router-link to="/resume">
            <em class="icon-file-text"></em> Resume
          </router-link>
        </li>
        <li class="nav__item">
          <router-link to="/portfolio">
            <em class="icon-codesandbox"></em> Portfolio
          </router-link>
        </li>
        <li class="nav__item">
          <router-link to="/blog">
            <em class="icon-book-open"></em> Blog
          </router-link>
        </li>
        <li class="nav__item">
          <router-link to="/contact">
            <em class="icon-book"></em> Contact
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'SidebarNav'
}
</script>
